import { IndividualsRepository, type WorkerContractSortKey } from "@/repositories/individuals.repository";
import type { SettableWorkerContractStatus } from "@shyne/shared/api";
import { uuid } from "@/interfaces";
import { organization_user_status } from "@/models/organization-user.model";

export async function searchIndividuals(
  page: number = 1,
  pageSize: number = 10,
  name?: string,
  service?: string,
  status?: organization_user_status,
  sortKey: WorkerContractSortKey = "name",
  sortOrder: "asc" | "desc" = "asc"
) {
  return IndividualsRepository.listByCurrentOrg(
    page,
    pageSize,
    name,
    service,
    status,
    sortKey,
    sortOrder
  );
}

export async function removeIndividualFromOrg(orgIndividualId: uuid) {
  return IndividualsRepository.remove(orgIndividualId);
}

export async function inviteIndividual(email: string, services: uuid[] = []) {
  return IndividualsRepository.inviteIndividual(email, services);
}

export async function updateIndividualStatus(orgIndividualId: uuid, status: SettableWorkerContractStatus) {
  return IndividualsRepository.setStatus(orgIndividualId, status);
}

export async function getIndividualDetail(orgIndividualId: uuid) {
  return IndividualsRepository.getDetail(orgIndividualId);
}

export async function updateIndividualServices(orgIndividualId: uuid, services: uuid[]) {
  return IndividualsRepository.setServices(orgIndividualId, services);
}

export async function uploadIndividualDocument(orgIndividualId: uuid, file: File, expiresAt?: string | Date) {
  return IndividualsRepository.uploadDocument(orgIndividualId, file, expiresAt);
}

export async function deleteIndividualDocument(docId: string) {
  return IndividualsRepository.deleteDocument(docId);
}

export async function updateIndividualDocumentExpiresAt(docId: string, expiresAt: string | Date | null) {
  return IndividualsRepository.updateDocumentExpiresAt(docId, expiresAt);
}

export async function listIndividualDocuments(orgIndividualId: uuid, page = 1, pageSize = 10) {
  return IndividualsRepository.listDocuments(orgIndividualId, page, pageSize);
}
